/* eslint-disable padding-line-between-statements */
import React, { useEffect, useState, useCallback, useContext } from "react";
import _ from 'lodash'
import { useModal } from "@jutro/components";
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication } from "@xengage/gw-digital-auth-react";
import metadata from './TWIABuildingList.metadata.json5'
import TWIAViewLocation from "../TWIAViewLocation/TWIAViewLocation";
import TWIAViewBuilding from "../TWIAViewBuilding/TWIAViewBuilding";
import messages from './TWIABuildingList.messages';
import { CpCoverablesService } from '../../../../capabilities/twia-capability-quoteandbind-cp';
import { BldgLocContext } from "../../context/BuildingsAndLocationContext";
import DeleteBuildingMessageUtil from '../../util/DeleteBuildingMessageUtil';
import { Link } from '@jutro/router';
function TWIABuildingList(props) {
    const {
        submissionVM,
        startWizard,
        newlyAddedBuildingList,
        setViewingLocationOrBuilding,
        selectedBuilding,
        setHasBuildingList,
        handleEditLinkClick,
        showViewLocation,
        showViewCoverages,
        setshowViewCoverages,
        wizardStep,
        showLocationAccordion,
        showBuildingAccordion,
        showConstructionAccordion,
        showCoverageAccordion,
        showStepper,
        showHideBuildingList,
        showAdditionalInterestAccordion,
        updateWizardData
    } = props
    const { authHeader } = useAuthentication();
    const [buildingList, setBuildingList] = useState([])
    const [selectedLocationNew, setSelectedLocationNew] = useState()
    const [selectBuilding, setSelectedBuilding] = useState()
    const { chosenLocation, chosenBuildingIndex } = useContext(BldgLocContext);
    const [selectedLocation, setSelectedLocation] = chosenLocation;
    const [selectedBuildingIndex, setSelectedBuildingIndex] = chosenBuildingIndex;
    const LocationDTOName = 'edge.capabilities.policyjob.lob.commercialproperty.coverables.dto.LocationDTO';
    const viewModelService = useContext(ViewModelServiceContext);
    const updatedLocationsValue = _.get(submissionVM, 'lobData.commercialProperty.coverables.locations.value')
    const { showConfirm } = useModal();
    const isRenewal = _.get(submissionVM, 'baseData.jobType.value.code') === 'Renewal';
    const isPolicyChange = _.get(submissionVM, 'baseData.jobType.value.code') === "PolicyChange";

    const buildingIsNewAddition = (buildingPID) => {
        if (newlyAddedBuildingList) {
            return _.includes(newlyAddedBuildingList, buildingPID);
        }
        return false;
    }

    const getBuildingsFromLocations = useCallback((buildings) => 
        _.sortBy(buildings,(location)=> location.locationNum_TWIA)
            .map(loc => {
                const address = loc.displayName;
                return (_.sortBy(loc.buildings,(bldg)=> bldg.buildingNumber)).map(building => ({
                    ...building,
                    description: building.description || building.name,
                    location: loc,
                    address,
                    isNewlyAdded: buildingIsNewAddition(building.publicID) || false,
                }));
            }).flat(), [buildingIsNewAddition])
    
    // DE15907- Fixes for Edit Links 
    const handleBack = useCallback(() => {
        if (showStepper === false) {
            showHideBuildingList(); 
            setBuildingList(getBuildingsFromLocations(updatedLocationsValue))         
        }
        else {
            setSelectedLocationNew();
            setSelectedBuilding();
            setBuildingList(getBuildingsFromLocations(updatedLocationsValue)) 
            setshowViewCoverages(false);
            setViewingLocationOrBuilding(false);
       }     
    }, [getBuildingsFromLocations, setViewingLocationOrBuilding, setshowViewCoverages, 
        showHideBuildingList, showStepper, updatedLocationsValue])

    useEffect(() => {
        const locations = _.get(submissionVM, 'lobData.commercialProperty.coverables.locations.value')
        setBuildingList(getBuildingsFromLocations(locations))
        if (showViewLocation) {
            setSelectedLocationNew(selectedLocation?.value);
        }
    }, [])

    // DE15781 and DE15990
    const setLocationAndBuilding = useCallback((building) => {
        const locations = _.get(submissionVM, 'lobData.commercialProperty.coverables.locations')
        const locData = _.find(locations.children,loc => loc.publicID.value === building.location.publicID)

        const buildingIndex = _.findIndex(building.location.buildings, (buildID) => buildID.publicID === building.publicID);
        setSelectedLocation(locData)
        setSelectedBuildingIndex(buildingIndex);
        submissionVM.selectedBuildingIndex = buildingIndex;
    }, [setSelectedBuildingIndex, setSelectedLocation, submissionVM])

    const setLocation = useCallback((location) => {
        const locationViewModel = viewModelService.create(
            location,
            'pc', LocationDTOName,
        );
        setSelectedLocation(locationViewModel)

    }, [setSelectedLocation, viewModelService])

    // DE15806
    const addBuildingToLocation = (value) => {
        submissionVM.selectedBuilding = null
        setLocationAndBuilding(value);
        setSelectedBuildingIndex(undefined)
        startWizard()

    }

    const addBuildingFromLocationLink = useCallback(()=>{
        setSelectedBuildingIndex(undefined)
        startWizard()
    })

    const handleBuildingLink = (building) => {
        setLocationAndBuilding(building)
        setSelectedBuilding(building);
        submissionVM.selectedBuilding = building;
        setSelectedLocationNew();
        setViewingLocationOrBuilding(true);
    }

    const renderAddressCell = (building) => {
        return (
            <div style={{ whiteSpace: 'break-spaces' }}>
                <Link onClick={() => { setSelectedLocationNew(building.location); setViewingLocationOrBuilding(true); setLocation(building.location) }}>{building.address}</Link>
            </div>
        )
    }

    const renderBuildingCell = (building) => {
        return (
            <div style={{ whiteSpace: 'break-spaces' }}>
                <Link onClick={() => handleBuildingLink(building)}>{building.description}</Link>
            </div>
        )
    }

    // US26251, DE15808, DE18640, DE18701
    const deleteBuilding = useCallback(async (building,index) => {       
        setSelectedBuildingIndex(undefined)
        await DeleteBuildingMessageUtil.deleteBuilding(building, submissionVM, showConfirm, authHeader, setHasBuildingList, setBuildingList,
            getBuildingsFromLocations, handleBack, updateWizardData,index);
    },[authHeader, getBuildingsFromLocations, handleBack, setHasBuildingList, 
        setSelectedBuildingIndex, showConfirm, submissionVM, updateWizardData])

    const setBuildingAndStartWizard = useCallback(() => {
        submissionVM.selectedBuilding = null
        setSelectedBuildingIndex(undefined)
        startWizard()
    }, [setSelectedBuildingIndex, startWizard, submissionVM])

    const renderCoverageForm = (building) => building.coverageForm

    const overrideProps = {
        buildingDataTable: {
            data: buildingList
        },
        buildingList: {
            visible: _.isUndefined(selectedLocationNew) && _.isUndefined(selectBuilding) && !showViewCoverages
        },
        locationView: {
            visible: !_.isUndefined(selectedLocationNew),
            location: selectedLocationNew,
            building: selectedBuilding,
            addBuildingFromLocationLink,
            backAction: handleBack,
            handleBuildingLink,
            handleEditLinkClick
        },
        buildingView: {
            visible: !_.isUndefined(selectBuilding) || showViewCoverages,
            building: _.get(selectedLocation,`buildings.value[${selectedBuildingIndex}]`),
            location:  _.get(selectedLocation,'value'),
            backAction: handleBack,
            startWizard,
            handleBuildingLink,
            handleEditLinkClick,
            submissionVM,
            setHasBuildingList,
            setBuildingList,
            getBuildingsFromLocations,
            wizardStep,
            showLocationAccordion,
            showBuildingAccordion,
            showConstructionAccordion,
            showCoverageAccordion,
            showAdditionalInterestAccordion,
            updateWizardData // DE18583
        },
        add: {
            visible: selectedBuilding?.coverageForm !== 'TWCR'
        },
        buildingListTitleButton: {
            visible: selectedBuilding?.coverageForm !== 'TWCR'
        },
        actionColumn:{
            visible: isPolicyChange && selectedBuilding?.coverageForm === 'TWCR' ? false : !isRenewal || selectedBuilding?.coverageForm !== 'TWCR' // DE17113
        }
    }

    const resolvers = {
        resolveCallbackMap: {
            renderAddressCell,
            renderBuildingCell,
            renderCoverageForm,
            setBuildingAndStartWizard,
            deleteBuilding,
            addBuildingToLocation
        },
        resolveComponentMap: {
            TWIAViewLocation,
            TWIAViewBuilding
        }
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    )
}

export default TWIABuildingList